import { useState } from "react";
import { Card, Form, Input, Button, Alert, Typography, Space } from "antd";
import { MailOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { forgetPassword } from "@/api/auth";

const { Title, Text, Paragraph } = Typography;

export function ForgetPassword() {
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (values: { email: string }) => {
    setLoading(true);
    try {
      await forgetPassword(values.email);
    } finally {
      // Backend luôn 200 không leak — UI cũng luôn show success message.
      setSent(true);
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f4f5f7",
      }}
    >
      <Card style={{ width: 420, padding: "16px 8px" }}>
        <Space direction="vertical" size="large" style={{ width: "100%" }}>
          <div style={{ textAlign: "center" }}>
            <Title level={3} style={{ margin: 0 }}>
              Quên mật khẩu
            </Title>
            <Text type="secondary">Nhập email để nhận link đặt lại mật khẩu.</Text>
          </div>

          {sent ? (
            <Alert
              type="success"
              message="Đã gửi yêu cầu"
              description="Nếu email tồn tại, link đặt lại mật khẩu đã được gửi. Vui lòng kiểm tra hộp thư (kể cả Spam)."
              showIcon
            />
          ) : (
            <Form layout="vertical" onFinish={handleSubmit} requiredMark={false}>
              <Form.Item
                name="email"
                label="Email"
                rules={[
                  { required: true, message: "Vui lòng nhập email." },
                  { type: "email", message: "Email không hợp lệ." },
                ]}
              >
                <Input prefix={<MailOutlined />} placeholder="alice@savina.vn" size="large" />
              </Form.Item>
              <Form.Item style={{ marginBottom: 0 }}>
                <Button type="primary" htmlType="submit" loading={loading} block size="large">
                  Gửi link đặt lại
                </Button>
              </Form.Item>
            </Form>
          )}

          <Paragraph style={{ textAlign: "center", marginBottom: 0 }}>
            <Link to="/login">
              <ArrowLeftOutlined /> Quay lại đăng nhập
            </Link>
          </Paragraph>
        </Space>
      </Card>
    </div>
  );
}

export default ForgetPassword;
